import React, { useState } from 'react';
import { Label } from 'reactstrap';

import { Switch } from '../../_components/switch';
import { useThemeContext } from '../../app/theme-provider';

import styles from './header.module.scss';
import logo from './images/ivc-logo-white.png';
import { SkipNavButton } from './skip-nav';

const getNewDarkModeData = (currentValue: string) => {
  const newThemeValue = currentValue === 'dark' ? 'light' : 'dark';
  // Given new value, describe if clicking toggle turns dark mode on or off
  const newDescription = newThemeValue === 'dark' ? 'off' : 'on';
  return [newThemeValue, newDescription] as const;
};

export default function Header() {
  const { theme, setTheme } = useThemeContext();
  const [toggleDescription, setToggleDescription] = useState(
    theme === 'dark' ? 'off' : 'on'
  );

  return (
    <header
      role="banner"
      aria-roledescription="VA Banner Heading"
      className={`${styles.header} p-1 d-flex justify-content-center align-items-center`}
    >
      <SkipNavButton />
      <div className={`ms-auto py-2 text-start text-sm-center`}>
        <a href="https://www.va.gov/COMMUNITYCARE/index.asp" tabIndex={0}>
          <img
            src={logo}
            alt="VA logo and Seal, U.S. Department of Veterans Affairs Veterans Health Administration, Office of Integrated Veteran Care"
            className={styles.logo}
          />
        </a>
      </div>
      <div className="ms-auto d-flex flex-column me-3">
        <Switch
          id="mode-switch"
          aria-label="Dark Mode"
          aria-description={`Press space to toggle dark mode ${toggleDescription}`}
          className={styles.switch}
          offColor="#5b616b"
          onColor="#323a45"
          uncheckedIcon={
            <small
              aria-hidden="true"
              className="fw-bold ms-1 text-white"
              style={{ position: 'absolute', top: '5px' }}
            >
              Off
            </small>
          }
          checkedIcon={
            <small
              aria-hidden="true"
              className="fw-bold ms-2 text-white"
              style={{ position: 'absolute', top: '5px' }}
            >
              On
            </small>
          }
          checked={theme === 'dark'}
          onChange={() => {
            const [value, description] = getNewDarkModeData(theme);
            setToggleDescription(description);
            setTheme(value);
          }}
        />
        <Label
          style={{ color: 'white', justifyContent: 'center', fontSize: '12px' }}
          aria-hidden="true"
        >
          Dark Mode
        </Label>
      </div>
    </header>
  );
}
